import { Component, OnInit, Input, Output } from '@angular/core';
import { KeywordManager } from '../../../core/keyword-manager';
import { EventEmitter } from '@angular/core';
import { Subscription, Subject, Observable } from 'rxjs';

@Component({
  selector: 'app-configuration-keyword',
  templateUrl: './configuration-keyword.component.html',
  styleUrls: ['./configuration-keyword.component.scss']
})
export class ConfigurationKeywordComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    this.loadComparisonKeywords.split(',').map(a => {
      if(a){
      this.keywordList.push({ textContent: a })
      }
    });
  }
  originalKeywordList: string = ''
  keywordList: { textContent: string ,[key:string]:string}[] = [];
  check: { textContent: string }[] = [];
  keywordToAdd: string = "";
  commaSepKeywords: string = "";
  @Input() loadComparisonKeywords = "";
  @Output() notify: EventEmitter<any> = new EventEmitter<any>();


  get invalidKeyword(): boolean {
    let keywordManager = new KeywordManager();
    let cleanedKeyword = keywordManager.CleanNoise(this.keywordToAdd.trim().toUpperCase());
    return cleanedKeyword == "";
  }

  addKeyordClick() {
    let keywordManager = new KeywordManager();
    let kw = this.keywordToAdd.trim().toUpperCase();
    kw = keywordManager.CleanNoise(kw);
    if (kw && kw != "" && kw.length > 1000) {
      this.confirmDlg("Keywords should not be more than 1000 chars long", "", "Keywords Confirmation", true)
    }
    else if (kw && kw != "" && kw.length <= 1000 && !this.keywordList.map(a => a.textContent).includes(kw)) {
      this.keywordList.push({ textContent: kw });
      this.commaSepKeywords = this.keywordList.map(a => a.textContent).join();
      this.keywordToAdd = "";
      this.notify.emit(this.commaSepKeywords);
    }
  }

  deleteKeyword(event) {
    const idx = this.keywordList.findIndex(keyword => keyword === event.item);
    this.keywordList.splice(idx, 1);
    this.commaSepKeywords = this.keywordList.map(a => a.textContent).join();
    this.notify.emit(this.commaSepKeywords);
  }

  onDeactivateDone: Subject<boolean> = null;
  openModal: boolean = false;
  dialogTitle: string = "";
  dialogTextLine1: string = "";
  dialogTextLine2: string = '';
  onDialogDone: Subject<boolean> = null;
  okCloseButtonClick(ok: boolean) {
    if (this.onDialogDone) {
      this.openModal = false;
      this.onDialogDone.next(ok);
    }
  }
  confirmDlg(msg: string, msg2: string, title: string, cancelButton: boolean = false): Observable<boolean> {
    this.dialogTitle = title;
    this.dialogTextLine1 = msg;
    this.dialogTextLine2 = msg2;
    this.openModal = true;
    this.onDialogDone = new Subject<boolean>();
    return this.onDialogDone.asObservable();
  }


}
